import { Menu, MenuItem } from "@muchbetteradventures/styleguide";
import React from "react";

var UserMenu = function UserMenu(_ref) {
  var anchorEl = _ref.anchorEl,
      isHost = _ref.isHost,
      isStaff = _ref.isStaff,
      loggedIn = _ref.loggedIn,
      onClose = _ref.onClose,
      onSignIn = _ref.onSignIn,
      onSignUp = _ref.onSignUp;
  var menuItems = [];

  if (loggedIn) {
    menuItems.push([/*#__PURE__*/React.createElement(MenuItem, {
      component: "a",
      href: isHost ? "/manager/inbox/" : "/inbox/",
      key: "bookings"
    }, "Bookings & Enquiries"), /*#__PURE__*/React.createElement(MenuItem, {
      component: "a",
      href: "/accounts/profile/",
      key: "account"
    }, "My Account"), /*#__PURE__*/React.createElement(MenuItem, {
      component: "a",
      href: "/shortlists/",
      key: "shortlist",
      divider: true
    }, "My Shortlist")]);

    if (isHost) {
      menuItems.push([/*#__PURE__*/React.createElement(MenuItem, {
        component: "a",
        href: "/manager/",
        key: "manager"
      }, "Manager"), /*#__PURE__*/React.createElement(MenuItem, {
        component: "a",
        href: "/manager/products/",
        key: "products"
      }, "My Products"), /*#__PURE__*/React.createElement(MenuItem, {
        component: "a",
        href: "/manager/companies/",
        key: "company",
        divider: true
      }, "My Company"), /*#__PURE__*/React.createElement(MenuItem, {
        component: "a",
        href: "https://help.muchbetteradventures.com/host-knowledge-base",
        key: "host-kb",
        divider: true
      }, "Host Knowledge Base")]);
    }

    if (isStaff) {
      menuItems.push([/*#__PURE__*/React.createElement(MenuItem, {
        component: "a",
        href: "/admin/",
        key: "admin"
      }, "Admin"), /*#__PURE__*/React.createElement(MenuItem, {
        component: "a",
        href: "/impersonate/search/",
        key: "impersonate",
        divider: true
      }, "Impersonate")]);
    }

    menuItems.push( /*#__PURE__*/React.createElement(MenuItem, {
      "data-cy": "menuitem-logout",
      component: "a",
      href: "/accounts/logout/?next=/",
      key: "logout"
    }, "Logout"));
  } else {
    menuItems.push([/*#__PURE__*/React.createElement(MenuItem, {
      onClick: function onClick() {
        onSignIn();
        onClose();
      },
      "data-cy": "menuitem-signin",
      key: "login"
    }, "Login"), /*#__PURE__*/React.createElement(MenuItem, {
      onClick: function onClick() {
        onSignUp();
        onClose();
      },
      "data-cy": "menuitem-signup",
      key: "signin"
    }, "Sign Up")]);
  }

  return /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: onClose
  }, menuItems);
};

export default UserMenu;